module.exports = __webpack_public_path__ + "static/media/home.955ff968.svg";